import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import DynamicPageLayout from "../common/DynamicPageLayout";
import { useExploratoryDetails } from "./useExploratoryDetails";

const ExploratoryDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const { exploratoryDetailsContentJson, timeLineDetails } =
    useExploratoryDetails();

  const handleDelete = () => {
    // console.info("You clicked the delete icon.");
  };

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate(`/exploratory-analysis/`)}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={2} mb={2}>
        <Grid item xs>
          <Typography
            variant="h4"
            gutterBottom
            className="dFlex alignItemsCenter"
          >
            EA1001 &nbsp;
            <Chip label="Created" color="info" variant="outlined" />
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item md={3}>
          <DynamicPageLayout
            pageContentJson={exploratoryDetailsContentJson}
            data={{}}
          />
          <br />
          <Button variant="contained">Upload testing report</Button>
          <br />

          <Chip
            label="IHC-PD-L1.pdf"
            size="small"
            color="primary"
            variant="outlined"
            onDelete={handleDelete}
            sx={{ mt: 1 }}
          />
        </Grid>
        <Grid item md={9}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Exploratory Analysis Journey
            </Typography>

            <TableContainer>
              <Table
                aria-label="simple table"
                stickyHeader
                sx={{
                  "& .MuiTableCell-body": {
                    borderBottom: "none",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>
                      <strong>Step</strong>
                    </TableCell>
                    <TableCell>
                      <strong>By</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Info/Alert</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {timeLineDetails.map((item, index) => (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={index}
                    >
                      <TableCell className="connected numberCell">
                        <CheckCircleIcon color="success" />
                        {/* <span className="numberCircle" /> */}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <strong>{item.step}</strong>
                      </TableCell>
                      <TableCell>{item.by}</TableCell>
                      <TableCell>{item.date}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell className="connected">
                      <span className="numberCircle">7</span>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <strong>Report Uploaded</strong>
                    </TableCell>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>&nbsp;</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ExploratoryDetails;
